import styled from 'styled-components';

export const Container = styled.div`
	max-width: 100vw;
	height: 100vh;
	background: #f0f0f0;
	display: flex;
	flex-direction: row;
	padding-left: 30px;
	//padding-right: 30px;
`;
